<template>
  <div>
    <v-checkbox
      v-for="(option, i) in optionObjects"
      :id="snInputProps_identifier"
      :key="'checkbox-' + snInputProps_identifier + '-' + i"
      v-model="response"
      :class="snInputProps_classes"
      :data-cy="option.value + '-checkbox'"
      data-test="checkboxes"
      :disabled="snInputProps_disabled"
      :error-messages="i === optionObjects.length - 1 ? errorMessages : null"
      :error="hasError(option)"
      :aria-label="option.label"
      :hide-details="snInputProps_hideDetails"
      :value="option.value"
      off-icon="$snCheckBox"
      on-icon="$snCheckBoxSelected"
      color="snBrand"
      dense
      @blur="$emit('blur')"
      @focus="$emit('focus')"
    >
      <template
        v-if="option.label !== option.text"
        v-slot:label
      >
        <div>
          <div
            class="sn-body-2"
            v-text="option.label"
          />
          <div
            class="sn-caption sn-text-primary-01"
            v-text="option.text"
          />
        </div>
      </template>

      <template
        v-else
        v-slot:label
      >
        <div v-text="option.label" />
      </template>
    </v-checkbox>
  </div>
</template>

<script>
import SnInputProps from '../../props/SnInputProps'
import deprecatedMixin from '~/components/snui/v2/_deprecated/deprecatedMixin.vue'
import { rgbaFromHexAndOpacity } from '~/assets/javascript/utilityFunctions.js'

export default {
  name: 'SnSelectCheckboxDeprecated',
  mixins: [deprecatedMixin],
  props: {
    ...SnInputProps,
    options: {
      type: Array,
      required: true,
      default () {
        return []
      }
    },
    value: {
      type: [String, Number, Array],
      default: '',
      required: false,
      deprecatedMixin: {
        alternativeComponent: 'SnCheckbox'
      }
    }
  },
  data () {
    return {
      response: [],
      optionObjects: []
    }
  },
  computed: {
    errorMessages () {
      const errors = this.snInputProps_errorMessages
      if (errors && !Array.isArray(errors) && typeof errors === 'object') {
        return this.response.map(value => errors[value]).filter(e => e).join(', ')
      } else if (Array.isArray((errors))) {
        return errors.join(', ')
      } else {
        return errors
      }
    }
  },
  watch: {
    value (newVal) {
      this.response = newVal
    },
    response (newVal) {
      this.$emit('input', this.response)
    }
  },
  created () {
    if (this.options.length && !this.options[0].value) {
      const optionObjects = []
      this.options.map((option) => {
        optionObjects.push({
          label: option,
          text: option,
          value: option
        })
      })
      this.optionObjects = optionObjects
    } else if (this.options.length) {
      this.optionObjects = this.options
    }

    const selectedOptions = []
    this.optionObjects.map((option) => {
      if (this.value?.includes(option.value)) {
        selectedOptions.push(option.value)
      }
    })

    this.response = selectedOptions
  },
  methods: {
    rgbaFromHexAndOpacity,
    hasError (option) {
      const errors = this.snInputProps_errorMessages
      if (errors && !Array.isArray(errors) && typeof errors === 'object') {
        return !!errors[option.value]
      } else if (Array.isArray(errors)) {
        return errors.length > 0
      } else {
        return !!errors
      }
    }
  }
}
</script>

<style lang="scss" scoped>
@import '~/assets/css/snui/index.scss';

.v-input--is-disabled {
  ::v-deep .v-input__slot {
    background-color: $sn-gray-01;
    border: 1px solid $sn-gray-04 !important;
    color: $sn-primary-01;

    .v-label.v-label--is-disabled {
      color: $sn-primary-01 !important;
    }
  }
}

.v-input--checkbox::v-deep.v-input--is-label-active .v-label {
  background: $sn-brand-01;
  .v-icon {
    color: $sn-brand;
  }
}

.v-input--checkbox::v-deep.v-input--is-label-active:hover {
  box-shadow: none;
}

.v-input--checkbox::v-deep {
  .v-label {
    border-radius: 2px;
    background-color: $sn-white;
    box-sizing: border-box;
    border: 1px solid $sn-gray-04;
    cursor:pointer;
    height: fit-content !important;
    min-height: 72px !important;
    padding-right: 50px !important;
    padding-left: 16px;
    padding-top: 12px;
    padding-bottom: 12px;
  }
  .v-label:hover {
    border: 1px solid $sn-brand !important;
    box-shadow: $sn-shadow-depth-1;
  }
  .v-label:focus-within {
    border: 1px solid $sn-primary !important;
  }
  .v-input--selection-controls__input {
    color: $sn-gray-04;
    z-index: 2;
  }

  margin-bottom: 15px;
}

::v-deep.v-input {
  font-family: $font-family-primary !important;
  margin-top: 0px;

  &.error--text {
    .v-input__slot {
      border: 1px solid #ff5252 !important;
    }
  }

  &:last-child {
    .v-input__slot {
      + .v-messages {
        display: flex;
        color: $sn-primary-01;

        .v-messages__message {
          font-size: 14px;
          line-height: 22px;
          margin-bottom: 20px;
        }

        &.error--text {
          color: #ff5252 !important;
          font-size: 15px;
          display: inline-flex;
          align-items: center;
          visibility: visible;

          &:before {
            content: '\26A0';
            margin-right: 5px;
            font-size: 15px;
            margin-bottom: 22px;
          }

          .v-messages__wrapper {
            display: inline-flex;
            padding-bottom: 2px;
          }
        }
      }
    }
  }

  .v-input__slot {
    + .v-messages {
      display: none;
    }

    .v-icon {
      color: $sn-gray-04;
    }

    .v-input--selection-controls__input {
      position: absolute;
      right: 10px;
    }
  }

  .error--text {
    color: rgba(0,0,0,.6) !important;

    &.v-icon {
      color: $sn-primary !important;
    }
  }
}
</style>
